// Web Share API with clipboard fallback. Uses the native iOS / Android /
// Win11 share sheet when available; falls back to clipboard + toast on
// desktop browsers that don't expose `navigator.share`. Returns a promise
// that resolves true on success, false on user-cancel / failure.
import { toast } from "sonner";

export async function shareUrl(url, label, description) {
  // Web Share API: feature-detect + only attempt on user gesture (this fn
  // must be called from a click handler). Some desktop Chrome / Edge expose
  // navigator.share without `canShare` so we check both.
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({
        title: label || "scartlead.tv",
        text: description || label || "",
        url,
      });
      return true;
    } catch (e) {
      // User-cancel throws AbortError on most browsers — that's fine, treat
      // as success-but-cancelled (no toast). Any other error → fall through
      // to clipboard so the user still gets the URL somehow.
      if (e && (e.name === "AbortError" || /cancell?ed/i.test(e.message || ""))) {
        return false;
      }
    }
  }
  // Clipboard fallback
  try {
    await navigator.clipboard.writeText(url);
    toast.success(label || "LINK COPIED", { description: description || url });
    return true;
  } catch (e) {
    toast.error("COPY FAILED", { description: url });
    return false;
  }
}
